import React, { useState } from 'react';
import {
    Button,
    Typography,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Box,
    Slide,
    Divider,
    Switch,
    FormControlLabel,
    Avatar,
    IconButton,
} from '@mui/material';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { ArrowBack } from '@mui/icons-material';
import { APP_CONFIG } from '../../../../../config/app.config';
import { useWarehouses } from '../../../hooks/useWarehouseOperations';

interface ManualWarehouseFormProps {
    onClose: () => void;
    onBack: () => void;
}

const ManualWarehouseForm: React.FC<ManualWarehouseFormProps> = ({
    onClose,
    onBack,
}) => {
    const [form, setForm] = useState({
        name: '',
        location: '',
    });

    const { createWarehouse, isCreating } = useWarehouses();

    const handleClose = () => {
        setForm({ name: '', location: '' });
        onClose();
    };

    const handleSubmit = () => {
        createWarehouse({
            name: form.name,
            location: form.location,
        });
        handleClose();
    };

    return (
        <>

            <DialogHeader>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center">
                        <IconButton onClick={onBack} color="inherit">
                            <ArrowBack />
                        </IconButton>

                        <Typography variant="h6" component="div">
                            Manual warehouse setup
                        </Typography>
                    </Stack>
                </Stack>
            </DialogHeader>

            <DialogContent sx={{ flex: 1, overflow: 'auto' }}>
                <Stack gap={3} sx={{ mt: 2 }}>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                           
                            <Box>
                                <Typography variant="h6" color="text.primary">
                                    Manual Warehouse Setup
                                </Typography>
                                <Typography variant="subtitle2" color="text.secondary">
                                    Create a warehouse that you can manage manually. You'll be able to add inventory data and connections later.
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>

                    <Divider />

                    <TextField
                        label="Warehouse Name"
                        fullWidth
                        required
                        value={form.name}
                        onChange={(e) => setForm(prev => ({ ...prev, name: e.target.value }))}
                    />

                    <TextField
                        label="Location"
                        fullWidth
                        value={form.location}
                        onChange={(e) => setForm(prev => ({ ...prev, location: e.target.value }))}
                        placeholder="e.g., Amsterdam, Netherlands"
                    />

                </Stack>
            </DialogContent>

            <DialogActions sx={{ p: 3, justifyContent: 'flex-end', borderTop: '1px solid', borderColor: APP_CONFIG.ui.theme.colors.border, position: 'absolute', bottom: 0, left: 0, right: 0 }}>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!form.name}
                >
                    Create Manual Warehouse
                </Button>
            </DialogActions>
        </>
    );
};

export default ManualWarehouseForm; 